import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import './AccountingReport.scss';

import commonConstant from '../../common/_commonConstant';
import { getCookieToken, randomNumber, trimSpace } from '../../common/_commonFunction';
import {
  fetchExportAccountingReports,
  fetchGetAccountingReports,
  fetchGetProfile,
  fetchAccountingSearchVehiclePlateOrReferenceCode,
} from '../../actions';
import {
  Badges,
  Checkbox,
  DatePicker,
  dateYYMMDDFormat,
  dateYYYYMMDD,
  dateYYYYMMDDTimeHHMMSS,
  history,
  IconVehicle,
  InputWithIcon,
  isAccounting,
  isSuperAdmin,
  labelPaymentMethod,
  labelVehicleType,
  minutesToHHMMSS,
  Modal,
  parkingTimeIn,
  parkingTimeOut,
  paymentUpdatedAt,
  reportTotalPaymentAmount,
  Table,
  totalCar,
  totalMotorcycle,
  totalVehicles,
  validateMoney,
  validateToShowDash,
  validateVehiclePlate,
  buildingRefNumber,
  buildingID,
  totalRecords,
  vehicleProvince,
  RadioButton,
  paymentID,
} from '../../helpers';
import { Loading } from '../../components';
import { BuildingNotFound } from '../../pages';

const columnHeader = [
  { 'label': 'ลำดับที่', 'className': 'number', 'sort': false, 'key': '' },
  { 'label': 'เลขที่ใบกำกับภาษี', 'className': 'tax-no', 'sort': true, 'key': 'payment-ref-no' },
  { 'label': 'วันเวลาชำระเงิน', 'className': 'payment-date', 'sort': false, 'key': '' },
  { 'label': 'เลขทะเบียน', 'className': 'vehicle-plate', 'sort': false, 'key': '' },
  { 'label': 'จังหวัด', 'className': 'vehicle-province', 'sort': false, 'key': '' },
  { 'label': 'ประเภทยานพาหนะ', 'className': 'vehicle-type', 'sort': false, 'key': '' },
  { 'label': 'Customer Type', 'className': 'customer-type', 'sort': false, 'key': '' },
  { 'label': 'Parking ref. no.', 'className': 'ref-no', 'sort': false, 'key': '' },
  { 'label': 'วันเวลาเข้า', 'className': 'time-in', 'sort': true, 'key': 'parking-time-in' },
  { 'label': 'วันเวลาออก', 'className': 'time-out', 'sort': true, 'key': 'parking-time-out' },
  { 'label': 'Charge Customer', 'className': 'charge-customer', 'sort': false, 'key': '' },
  { 'label': 'เวลาจอด', 'className': 'time-park', 'sort': false, 'key': '' },
  { 'label': 'Payment Method', 'className': 'payment-method', 'sort': false, 'key': '' },
  { 'label': 'Payment Ref.', 'className': 'payment-ref', 'sort': false, 'key': '' },
  { 'label': 'ค่าปรับ', 'className': 'fee', 'sort': false, 'key': '' },
  { 'label': 'ค่าบริการ', 'className': 'amount', 'sort': false, 'key': '' },
  { 'label': 'VAT', 'className': 'vat', 'sort': false, 'key': '' },
  { 'label': 'ค่าบริการสุทธิ', 'className': 'total-amount', 'sort': true, 'key': 'total-payment-amount' },
  { 'label': 'Payment Note', 'className': 'payment-note', 'sort': false, 'key': '' },
  { 'label': 'Redeem Ref.', 'className': 'redeem-ref', 'sort': false, 'key': '' },
  { 'label': 'Redemption Type', 'className': 'redemption-type', 'sort': false, 'key': '' },
];
const passFuncBody = [
  (data, objToPassFuncBody, pageSize, pageNumber, index) => ((pageSize * (pageNumber - 1)) + (index + 1)),
  data => validateToShowDash(data.paymentRefNo),
  data => validateToShowDash(dateYYYYMMDDTimeHHMMSS(paymentUpdatedAt(data))),
  data => validateToShowDash(data.vehicleLicensePlate),
  data => validateToShowDash(vehicleProvince(data)),
  data => validateToShowDash(labelVehicleType(data)),
  data => validateToShowDash(data.customerType),
  data => validateToShowDash(data.parkingRefNo),
  data => validateToShowDash(dateYYYYMMDDTimeHHMMSS(parkingTimeIn(data))),
  data => validateToShowDash(dateYYYYMMDDTimeHHMMSS(parkingTimeOut(data))),
  data => validateToShowDash(data.chargeCustomer),
  data => validateToShowDash(minutesToHHMMSS(data.parkingTotalParkingTimeMinutes)),
  data => validateToShowDash(labelPaymentMethod(data)),
  data => validateToShowDash(paymentID(data)),
  data => validateToShowDash(data.paymentTotalFinesExclVatAmount),
  data => validateToShowDash(data.paymentTotalParkingFeeExclVatAmount),
  data => validateToShowDash(data.paymentTotalVatAmount),
  data => validateToShowDash(data.paymentTotalInclVatAmount),
  data => validateToShowDash(data.paymentNote),
  data => validateToShowDash(data.tenantParkingPackageRefCodes),
  data => validateToShowDash(data.redemptionType),
];

class AccountingReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortAccountingReport,
      'inputFilter': '',
      'filter': [],
      'filterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterPaymentMethod),
        ...JSON.parse(commonConstant.defaultFilterIsRedeem),
        ...JSON.parse(commonConstant.defaultFilterFines),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
      },
      'selectFilterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterPaymentMethod),
        ...JSON.parse(commonConstant.defaultFilterIsRedeem),
        ...JSON.parse(commonConstant.defaultFilterFines),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
      },
      'filterInput': [],
      'fromDate': dateYYYYMMDD(new Date()),
      'toDate': dateYYYYMMDD(new Date()),
      'selectTypeDate': 1,
      'loading': true,
      'modal': null,
      'sumFilterModal': 0,
      'showAutoFill': false,
      'dataAutoFill': null,
      'typeSearch': 'vehicleLicensePlate',
    };
    if (!getCookieToken()) {
      return history.push(commonConstant.pathLogout);
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.getProfile.data && (isSuperAdmin(this.props.getProfile.data) || isAccounting(this.props.getProfile.data))) {
      this.handleClearState();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { typeSearch } = this.state;
    const {
      getAccountingReports,
      exportAccountingReports,
      getProfile,
      accountingSearchVehiclePlateOrReferenceCode,
      match,
    } = this.props;

    if (nextProps.getAccountingReports && nextProps.getAccountingReports && nextProps.getAccountingReports !== getAccountingReports) {
      return this.setState({ 'loading': false });
    } else if (nextProps.exportAccountingReports && nextProps.exportAccountingReports !== exportAccountingReports) {
      if (nextProps.exportAccountingReports.status === 200) {
        const element = document.createElement('a');
        const id = new Date(nextProps.exportAccountingReports.dateTime).getTime();
        element.setAttribute('href', window.URL.createObjectURL(new Blob([nextProps.exportAccountingReports.blob])));
        element.setAttribute('download', `accounting_report_${nextProps.match.params.buildingRefNo}_${dateYYMMDDFormat(new Date())}.xlsx`);
        element.setAttribute('id', `dummy-link-${id}`);
        document.getElementById('dummy-export').appendChild(element);

        return this.setState({ 'loading': false, 'modal': 'success' }, () => this.handleDownloadReport(id));
      }
      return this.setState({ 'loading': false, 'modal': 'fail' });
    } else if (nextProps.getProfile && nextProps.getProfile && nextProps.getProfile !== getProfile) {
      if (isSuperAdmin(nextProps.getProfile.data) || isAccounting(nextProps.getProfile.data)) {
        return this.handleClearState(nextProps);
      }
      return this.setState({ 'loading': false });
    } else if (nextProps.match.url !== match.url) {
      if (!nextProps.getProfile.data) {
        return this.props.dispatch(fetchGetProfile());
      } else if (
        isSuperAdmin(nextProps.getProfile.data) ||
        isAccounting(nextProps.getProfile.data) ||
        nextProps.match.params.buildingRefNo === buildingRefNumber(nextProps.getProfile.data)
      ) {
        return this.handleClearState(nextProps);
      }
    } else if (
      nextProps.accountingSearchVehiclePlateOrReferenceCode
      && nextProps.accountingSearchVehiclePlateOrReferenceCode !== accountingSearchVehiclePlateOrReferenceCode
      && nextProps.accountingSearchVehiclePlateOrReferenceCode.metadata
      && nextProps.accountingSearchVehiclePlateOrReferenceCode.metadata.searchKeywords
    ) {
      const searchKeywords = nextProps.accountingSearchVehiclePlateOrReferenceCode.metadata.searchKeywords[typeSearch === 'vehicleLicensePlate' ? 'vehicleLicensePlates' : 'parkingRefNos'];
      this.setState({
        'showAutoFill': true,
        'dataAutoFill': searchKeywords !== '' && searchKeywords.split(',').map((ele, index) => (
          <div className="item" key={randomNumber()} onClick={() => this.handleFilterInput(ele)}>
            <span className="text" id={`vehicle-auto-fill-${index}`}>
              {ele}
            </span>
          </div>
        )),
      });
    }
  }

  handleDownloadReport = (id) => {
    const element = document.getElementById(`dummy-link-${new Date(id).getTime()}`);

    if (element) {
      element.click();
      element.remove();
    }

    return null;
  }

  handlePageChange = pageNumber => {
    const { fromDate, toDate, pageSize, sort } = this.state;

    this.setState({ pageNumber, 'loading': true });
    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handlePageSize = pageSize => {
    const { fromDate, toDate, sort } = this.state;

    this.setState({ pageSize, 'pageNumber': 1, 'loading': true });
    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleSort = sort => {
    const { fromDate, toDate, pageSize, pageNumber } = this.state;

    this.setState({ sort, 'loading': true });

    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleSelectDate = (fromDate, toDate, selectTypeDate) => {
    const { sort } = this.state;

    this.setState({
      fromDate,
      toDate,
      selectTypeDate,
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
    });
    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment'),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleBodyModal = () => {
    const { modal, selectFilterCheckbox } = this.state;
    const { getProfile } = this.props;

    switch (modal) {
      case 'filter':
        return (
          <div className="filter-box">
            <div className="select-filter">
              <div className="type">
                <div className="title">Payment Method</div>
                <Checkbox
                  id="filter-cash"
                  label={selectFilterCheckbox.cash.label}
                  checked={selectFilterCheckbox.cash.select}
                  handleSelect={() => this.handleFilterModal('cash')}
                />
                {
                  isSuperAdmin(getProfile.data) ?
                    <div>
                      <Checkbox
                        id="filter-credit-card"
                        label={selectFilterCheckbox.creditCard.label}
                        checked={selectFilterCheckbox.creditCard.select}
                        handleSelect={() => this.handleFilterModal('creditCard')}
                      />
                      <Checkbox
                        id="filter-promptpay-mobile"
                        label={selectFilterCheckbox.promptpayMobile.label}
                        checked={selectFilterCheckbox.promptpayMobile.select}
                        handleSelect={() => this.handleFilterModal('promptpayMobile')}
                      />
                      <Checkbox
                        id="filter-promptpay-kiosk"
                        label={selectFilterCheckbox.promptpayKiosk.label}
                        checked={selectFilterCheckbox.promptpayKiosk.select}
                        handleSelect={() => this.handleFilterModal('promptpayKiosk')}
                      />
                      <Checkbox
                        id="filter-promptpay-tablet"
                        label={selectFilterCheckbox.promptpayTablet.label}
                        checked={selectFilterCheckbox.promptpayTablet.select}
                        handleSelect={() => this.handleFilterModal('promptpayTablet')}
                      />
                      <Checkbox
                        id="filter-promptpay-kiosk-parking-gate"
                        label={selectFilterCheckbox.promptpayKioskParkingGate.label}
                        checked={selectFilterCheckbox.promptpayKioskParkingGate.select}
                        handleSelect={() => this.handleFilterModal('promptpayKioskParkingGate')}
                      />
                      <Checkbox
                        id="filter-linepay"
                        label={selectFilterCheckbox.linePay.label}
                        checked={selectFilterCheckbox.linePay.select}
                        handleSelect={() => this.handleFilterModal('linePay')}
                      />
                    </div>
                    : <Checkbox
                      id="filter-ezy-payment"
                      label={selectFilterCheckbox.ezyPayment.label}
                      checked={selectFilterCheckbox.ezyPayment.select}
                      handleSelect={() => this.handleFilterModal('ezyPayment')}
                    />
                }
              </div>
              <div className="type">
                <div className="title">Redeem</div>
                <Checkbox
                  id="filter-redeem"
                  label={selectFilterCheckbox.redeem.label}
                  checked={selectFilterCheckbox.redeem.select}
                  handleSelect={() => this.handleFilterModal('redeem')}
                />
                <Checkbox
                  id="filter-not-redeem"
                  label={selectFilterCheckbox.notRedeem.label}
                  checked={selectFilterCheckbox.notRedeem.select}
                  handleSelect={() => this.handleFilterModal('notRedeem')}
                />
              </div>
              <div className="type">
                <div className="title">ประเภทรถ</div>
                <Checkbox
                  id="filter-car"
                  label={selectFilterCheckbox.car.label}
                  checked={selectFilterCheckbox.car.select}
                  handleSelect={() => this.handleFilterModal('car')}
                />
                <Checkbox
                  id="filter-motorcycle"
                  label={selectFilterCheckbox.motorcycle.label}
                  checked={selectFilterCheckbox.motorcycle.select}
                  handleSelect={() => this.handleFilterModal('motorcycle')}
                />
              </div>
              <div className="type">
                <div className="title">ค่าปรับ</div>
                <Checkbox
                  id="filter-has-fines"
                  label={selectFilterCheckbox.hasFines.label}
                  checked={selectFilterCheckbox.hasFines.select}
                  handleSelect={() => this.handleFilterModal('hasFines')}
                />
                <Checkbox
                  id="filter-not-fines"
                  label={selectFilterCheckbox.notFines.label}
                  checked={selectFilterCheckbox.notFines.select}
                  handleSelect={() => this.handleFilterModal('notFines')}
                />
              </div>
            </div>
            <div className="box-btn">
              <Button className="btn-primary" id="btn-apply-filter" onClick={this.handleApplyFilterModal}>
                Apply
              </Button>
            </div>
          </div>
        );
      case 'success':
        return (
          <div className="export-success">
            <img className="icon" src={commonConstant.checkImg} alt=""/>
            <div className="text" id="export-status">Download successful!</div>
            <Button className="btn-primary" id="btn-ok" onClick={this.handleShowModal}>OK</Button>
          </div>
        );
      case 'fail':
        return (
          <div className="export-fail">
            <img className="icon" src={commonConstant.warningImg} alt=""/>
            <div className="text" id="export-status">An error occurred.</div>
            <div className="text">Please try again later.</div>
            <Button className="btn-primary" id="btn-ok" onClick={this.handleShowModal}>OK</Button>
          </div>
        );
      default:
        return null;
    }
  }

  handleHeaderModal = () => {
    const { modal } = this.state;

    switch (modal) {
      case 'filter':
        return this.handleSumFilter();
      case 'success':
        return 'Download .xls file';
      case 'fail':
        return 'Download .xls file';
      default:
        return null;
    }
  }

  handleShowModal = value => this.setState({
    'modal': this.state.modal ? null : value,
    'selectFilterCheckbox': { ...this.state.filterCheckbox }, // clear filter on modal (unapply)
  });

  handleFilterModal = key => { // handle filter modal (checkbox)
    this.setState({
      'selectFilterCheckbox': {
        ...this.state.selectFilterCheckbox,
        [key]: { ...this.state.selectFilterCheckbox[key], 'select': !this.state.selectFilterCheckbox[key].select },
      },
    });
  }

  handleApplyFilterModal = () => { // apply filter form modal
    const { sort, fromDate, toDate, selectFilterCheckbox } = this.state;
    const arr = this.handleBadgesItems();

    this.setState({
      'modal': null,
      'filterCheckbox': { ...selectFilterCheckbox },
      'selectFilterCheckbox': { ...selectFilterCheckbox },
      'filter': arr,
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sumFilterModal': this.handleSumFilter(),
    });
    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate', arr),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment', arr),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleSumFilter = () => {
    const { selectFilterCheckbox } = this.state;
    let sum = 0;

    Object.keys(selectFilterCheckbox).forEach(ele => selectFilterCheckbox[ele].select ? sum += 1 : null);

    return (
      <span className="box-sum">
        <span>Filter</span>
        {sum ? <span className="sum" id="filter-summary">{sum}</span> : null}
      </span>
    );
  }

  handleBadgesItems = newFilterInput => { // handle filter for badges
    try {
      const { selectFilterCheckbox, filterInput } = this.state;
      const input = newFilterInput ? newFilterInput : filterInput;
      const arr = input ? [...input] : [];

      Object.keys(selectFilterCheckbox).forEach(key => {
        if (selectFilterCheckbox[key].select) {
          arr.push({
            'label': selectFilterCheckbox[key].label,
            'value': selectFilterCheckbox[key].value,
            'key': 'filterCheckbox',
            'keyName': selectFilterCheckbox[key].keyName,
            'type': selectFilterCheckbox[key].type,
          });
        }
      });
      return arr;
    } catch (error) {
      return null;
    }
  }

  handleInput = event => {
    const { typeSearch, fromDate, toDate } = this.state;

    if (validateVehiclePlate(event.target.value)) {
      if (event.target.value.length >= 3) {
        this.props.dispatch(fetchAccountingSearchVehiclePlateOrReferenceCode(
          this.props.match.params.buildingRefNo,
          typeSearch === 'vehicleLicensePlate' && event.target.value,
          typeSearch === 'parkingRef' && event.target.value,
          dateYYYYMMDD(fromDate),
          dateYYYYMMDD(toDate),
          this.handleFilterVehicleType(),
        ));
        return this.setState({ 'inputFilter': event.target.value });
      }
      return this.setState({ 'inputFilter': event.target.value, 'showAutoFill': false });
    }
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      return this.handleFilterInput();
    }
  }

  handleFilterInput = async selectFilter => { // add filter from input
    const { inputFilter, filterInput, fromDate, toDate, sort, typeSearch } = this.state;
    const input = selectFilter ? selectFilter : inputFilter;
    const check = await filterInput.find(element => element.value === input);

    if (check || !inputFilter) {
      return null;
    }
    const newFilterInput = [...filterInput, {
      'label': input,
      'value': input,
      'key': 'filterInput',
      'keyName': input,
      'type': typeSearch,
    }];
    const arr = this.handleBadgesItems(newFilterInput);

    this.setState({
      'filterInput': newFilterInput,
      'filter': arr,
      'inputFilter': '',
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'showAutoFill': false,
      'dataAutoFill': null,
    });
    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate', arr),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment', arr),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef', arr),
    ));
  }

  handleRemoveFilter = index => { // remove filter from badges
    const { filter, filterInput, filterCheckbox, fromDate, toDate, sort } = this.state;
    let newFilterInput = null;

    if (filter[index].key === 'filterInput') {
      newFilterInput = filterInput.filter(element => element.label !== filter[index].label);
    } else if (filter[index].key === 'filterCheckbox') {
      filterCheckbox[filter[index].keyName].select = false;
    }

    const arr = this.handleBadgesItems(newFilterInput ? newFilterInput : filterInput);

    this.setState({
      'filter': arr,
      filterCheckbox,
      'filterInput': newFilterInput ? newFilterInput : filterInput,
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
    });
    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate', arr),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment', arr),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef', arr),
    ));
  }

  handleFilterByType = (type, filter) => {
    const newFilter = filter ? filter : this.state.filter;
    const arr = [];

    newFilter.forEach(ele => ele.type === type ? arr.push(trimSpace(ele.value)) : null);
    return arr.join(',');
  }

  handleFilterIsRedeem = newFilter => {
    const { selectFilterCheckbox } = this.state;
    const checkFilterRedeem = newFilter ? newFilter : selectFilterCheckbox;

    if (checkFilterRedeem.redeem.select && checkFilterRedeem.notRedeem.select) {
      return null;
    } else if (checkFilterRedeem.redeem.select) {
      return true;
    } else if (checkFilterRedeem.notRedeem.select) {
      return false;
    }
    return null;
  }

  handleFilterHasFines = newFilter => {
    const { selectFilterCheckbox } = this.state;
    const checkFilterRedeem = newFilter ? newFilter : selectFilterCheckbox;

    if (checkFilterRedeem.hasFines.select && checkFilterRedeem.notFines.select) {
      return null;
    } else if (checkFilterRedeem.hasFines.select) {
      return true;
    } else if (checkFilterRedeem.notFines.select) {
      return false;
    }
    return null;
  }

  handleFilterVehicleType = newFilter => {
    const { selectFilterCheckbox } = this.state;
    const checkFilterRedeem = newFilter ? newFilter : selectFilterCheckbox;

    if (checkFilterRedeem.car.select && checkFilterRedeem.motorcycle.select) {
      return null;
    } else if (checkFilterRedeem.car.select) {
      return checkFilterRedeem.car.value;
    } else if (checkFilterRedeem.motorcycle.select) {
      return checkFilterRedeem.motorcycle.value;
    }
    return null;
  }

  handleExportAccountingReport = () => {
    const { fromDate, toDate } = this.state;

    this.setState({ 'loading': true });
    document.getElementById('dummy-export').innerHTML = '';
    return this.props.dispatch(fetchExportAccountingReports(
      this.props.match.params.buildingRefNo,
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
    ));
  }

  handleClearState = nextProps => {
    const props = nextProps ? nextProps : this.props;

    this.setState({
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortAccountingReport,
      'inputFilter': '',
      'filter': [],
      'filterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterPaymentMethod),
        ...JSON.parse(commonConstant.defaultFilterIsRedeem),
        ...JSON.parse(commonConstant.defaultFilterFines),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
      },
      'selectFilterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterPaymentMethod),
        ...JSON.parse(commonConstant.defaultFilterIsRedeem),
        ...JSON.parse(commonConstant.defaultFilterFines),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
      },
      'filterInput': [],
      'fromDate': dateYYYYMMDD(new Date()),
      'toDate': dateYYYYMMDD(new Date()),
      'selectTypeDate': 1,
      'loading': true,
      'modal': null,
    });

    return this.props.dispatch(fetchGetAccountingReports(
      props.match.params.buildingRefNo,
      null,
      null,
      null,
      dateYYYYMMDD(new Date()),
      dateYYYYMMDD(new Date()),
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortAccountingReport.key,
      commonConstant.defaultSortAccountingReport.sort ? 'descending' : 'ascending',
      null,
      null,
    ));
  }

  handleResetFilter = () => {
    const { fromDate, toDate, filterInput } = this.state;

    this.setState({
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortAccountingReport,
      'filter': [...filterInput],
      'filterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterPaymentMethod),
        ...JSON.parse(commonConstant.defaultFilterIsRedeem),
        ...JSON.parse(commonConstant.defaultFilterFines),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
      },
      'selectFilterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterPaymentMethod),
        ...JSON.parse(commonConstant.defaultFilterIsRedeem),
        ...JSON.parse(commonConstant.defaultFilterFines),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
      },
      'sumFilterModal': 0,
    });
    return this.props.dispatch(fetchGetAccountingReports(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterIsRedeem(),
      this.handleFilterByType('payment'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortAccountingReport.key,
      commonConstant.defaultSortAccountingReport.sort ? 'descending' : 'ascending',
      this.handleFilterVehicleType(),
      this.handleFilterHasFines(),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleTypeSearch = typeSearch => {
    this.setState({ typeSearch });
  }

  render() {
    const {
      pageSize,
      pageNumber,
      sort,
      filter,
      inputFilter,
      fromDate,
      toDate,
      modal,
      loading,
      selectTypeDate,
      typeSearch,
      showAutoFill,
      dataAutoFill,
    } = this.state;
    const { getAccountingReports, getProfile, match } = this.props;

    if (!getProfile.data || !getAccountingReports.data) {
      return <Loading/>;
    } else if (isAccounting(getProfile.data) && match.params.buildingID !== buildingID(getProfile.data)) {
      return <BuildingNotFound/>;
    }

    return (
      <div className={`AccountingReport ${isAccounting(getProfile.data) ? 'no-sidebar-layout' : 'layout-box-page'}`}>
        {loading ? <Loading /> : null}
        <div href="" className="dummy-export" id="dummy-export" />
        <div className="radio-button-box">
          <div className="licensee-plate-radio-button-box">
            <RadioButton checked={typeSearch === 'vehicleLicensePlate'} label={'ค้นหาจากทะเบียยนรถ'}
              handleSelect={() => this.handleTypeSearch('vehicleLicensePlate')} />
          </div>
          <div className="reference-code-radio-button-box">
            <RadioButton checked={typeSearch === 'parkingRef'} label={'ค้นหาจากรหัสอ้างอิง'}
              handleSelect={() => this.handleTypeSearch('parkingRef')} />
          </div>
        </div>
        <div className="tool-bar">
          <div className="box-filter">
            <InputWithIcon
              id="search-license-plate"
              template="b"
              value={inputFilter}
              icon="fas fa-search"
              placeholder="ค้นหาจากเลขทะเบียนรถ"
              onKeyPress={this.handleKeyPress}
              onChange={this.handleInput}
              showAutoFill={showAutoFill}
              dataAutoFill={dataAutoFill}
            />
            <Button className="btn-secondary btn-filter" id="btn-filter" onClick={() => this.handleShowModal('filter')}>
              Filter
              <span className="icon fas fa-filter"/>
            </Button>
            <span className="label-date">ช่วงเวลา</span>
            <DatePicker id="filter-date" placeholder="เลือกช่วงเวลา" selectType={selectTypeDate} fromDate={fromDate}
              toDate={toDate} handleSelectDate={this.handleSelectDate}/>
          </div>
          <div className="box-export">
            <Button
              className="btn-primary btn-excel"
              id="btn-download-excel"
              onClick={this.handleExportAccountingReport}
              disabled={getAccountingReports.data.length > 0 ? false : true}
            >
              <span className="icon icon-download"/>
              ดาวน์โหลดไฟล์ excel
            </Button>
          </div>
        </div>
        <Badges items={filter} handleRemove={this.handleRemoveFilter}/>
        <div className={`section-table${filter.length > 0 ? ' mr' : ''}`}>
          <div className="box-detail">
            <div className="box-detail-vehicle">
              <span>
                จำนวนรถทั้งหมด
                <span className="green"
                  id="total-vehicle">{validateToShowDash(totalVehicles(getAccountingReports) ? totalVehicles(getAccountingReports).toLocaleString() : null)}</span>
                คัน
              </span>
              <span>
                <IconVehicle className="icon" name="icon_car"/>
                <span className="green"
                  id="total-car">{validateToShowDash(totalCar(getAccountingReports) ? totalCar(getAccountingReports).toLocaleString() : null)}</span>
                คัน
              </span>
              <span>
                <IconVehicle className="icon" name="icon_motorcycle"/>
                <span className="green"
                  id="total-motorcycle">{validateToShowDash(totalMotorcycle(getAccountingReports) ? totalMotorcycle(getAccountingReports).toLocaleString() : null)}</span>
                คัน
              </span>
            </div>
            <div className="box-detail-amount">
              ยอดค่าจอดสุทธิ
              <span className="green"
                id="total-amount">{validateMoney(reportTotalPaymentAmount(getAccountingReports))}</span>
              บาท
            </div>
          </div>
          <Table
            id="table-accounting-report"
            columnHeader={columnHeader}
            data={getAccountingReports.data}
            passFuncBody={passFuncBody}
            maxData={validateToShowDash(totalRecords(getAccountingReports))}
            pageSize={pageSize}
            pageNumber={pageNumber}
            handlePageChange={this.handlePageChange}
            sort={sort}
            isSort
            handleSort={this.handleSort}
            handlePageSize={this.handlePageSize}
            filter={filter}
            objToPassFuncBody={{
              'isSuperAdmin': isSuperAdmin(getProfile.data),
            }}
          />
        </div>
        <Modal
          show={modal ? true : false}
          header={this.handleHeaderModal()}
          handleToggle={this.handleShowModal}
          iconOther={
            modal === 'filter' ?
              <span className="reset" id="modal-reset-filter" onClick={this.handleResetFilter}>
                <span className="icon fas fa-redo-alt"/>
                <span className="text">Reset</span>
              </span>
              : null
          }
        >
          {this.handleBodyModal()}
        </Modal>
      </div>
    );
  }
}

AccountingReport.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingID': PropTypes.string.isRequired,
      'buildingRefNo': PropTypes.string.isRequired,
    }),
    'url': PropTypes.string,
  }),
  'getAccountingReports': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.array,
    'metadata': PropTypes.shape({
      'pagination': PropTypes.shape({
        'totalRecords': PropTypes.number,
      }),
      'summary': PropTypes.shape({
        'totalVehicles': PropTypes.number,
        'totalNetParkingFees': PropTypes.number,
      }),
    }),
  }),
  'exportAccountingReports': PropTypes.shape({
    'status': PropTypes.any,
    'blob': PropTypes.any,
    'dateTime': PropTypes.any,
  }),
  'getProfile': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'building': PropTypes.shape({
        'buildingRefNo': PropTypes.string,
        'buildingID': PropTypes.string,
      }),
    }),
  }),
  'accountingSearchVehiclePlateOrReferenceCode': PropTypes.shape({
    'status': PropTypes.any,
    'metadata': PropTypes.shape({
      'searchKeywords': PropTypes.string,
    }),
  }),
};

const mapStateToProps = ({
  getAccountingReports,
  exportAccountingReports,
  getProfile,
  accountingSearchVehiclePlateOrReferenceCode,
}) => ({
  getAccountingReports,
  exportAccountingReports,
  getProfile,
  accountingSearchVehiclePlateOrReferenceCode,
});

export default connect(mapStateToProps)(AccountingReport);
